import { type Enum } from '@webapp/infrastructure/types/Enum'

// Extended in future stories: LOADING, RESULTS, UNSUPPORTED_QUERY, EMPTY, ERROR
export const ContentStates = {
  RECENTS: 'recents',
} as const

export type ContentStateEnum = Enum<typeof ContentStates>
